import restartProspectus from '@actions/restartProspectus';
import Btn from '@components/Btn';
import { useSelector, useDispatch } from 'react-redux';

export default function StartOver({ classes = ['outline', 'mb-2', 'outline--home'] }) {
	const dispatch = useDispatch();

	const { prospectusId, authenticated } = useSelector((state) => state.user);

	const handleClick = () => {
		dispatch(restartProspectus(authenticated && prospectusId));
	};

	if (authenticated && prospectusId) {
		return (
			<Btn onClick={handleClick} customClass={classes}>
				Start Over
			</Btn>
		);
	}
}
